export default "__VITE_ASSET__da6ffc81__"